module.exports = __webpack_public_path__ + "media/images/area/popular/asakusa-166e64aae60f306e4ce2c8e46046a6fc.jpg";